import React from 'react'
import { FeedItem } from 'Api'
import { colors } from 'Components/consts'
import { Play } from 'Components/Icons'
import { convertHourMinSec } from 'Utils/formatting/formatting'
import {
  AdditionalVidCon,
  VideoLink,
  VideoThumbSmall,
  VideoPlaceholder,
} from '../styles'
import { Img } from 'Components/Image/Img'
import { getCurrentOrigin } from 'Utils'

type VideoParams = {
  video: FeedItem
  videoIdx?: number
  tag: string | null
  onSelect: (mediaId: string) => void
}

export const AdditionalVideo: React.FC<VideoParams> = ({ video, tag }) => {
  const getVideoDuration = () => {
    if (!video?.duration) return ''
    return convertHourMinSec(video.duration)
  }

  const getUrl = () => {
    return tag
      ? `${getCurrentOrigin()}/videos/tag/${tag}?mediaId=${video.mediaId}`
      : `${getCurrentOrigin()}/videos/${video.mediaId}`
  }

  return (
    <VideoLink href={getUrl()} aria-label={`Watch ${video.title || 'video'}`}>
      <AdditionalVidCon>
        {video.previewImage ? (
          <VideoThumbSmall
            backgroundImg={video.previewImage}
            aspectRatio={video.aspectRatio}
          >
            <div
              className="blurredBg"
              style={{ backgroundImage: `url(${video.previewImage})` }}
            />
            <div className="imgCon">
              <Img src={video.previewImage} alt={video.title || 'Video thumbnail'} />
            </div>
            <Play className="playBtn" width={35} height={35} fill={colors.white} />
            {getVideoDuration() && (
              <div className="durationCon">
                <div className="durationText">{getVideoDuration()}</div>
              </div>
            )}
          </VideoThumbSmall>
        ) : (
          <VideoThumbSmall aspectRatio={video?.aspectRatio ?? '16/9'}>
            <div className="imgCon">
              <VideoPlaceholder>
                <Play width={35} height={35} fill={colors.gray.gray60} />
              </VideoPlaceholder>
            </div>
          </VideoThumbSmall>
        )}
        <div className="infoCon">
          <div className="title">{video.title}</div>
          <div className="durationCon">
            <div className="durationText">{getVideoDuration()}</div>
          </div>
        </div>
      </AdditionalVidCon>
    </VideoLink>
  )
}
